import { FC, memo, useMemo } from 'react'
import { Container, ContentWrapper, CustomMarkdown, FAQItem, Question, TitleSubtitleWrapper } from './styles'
import FAQTransport from '../../../transports/common/faq-transport'
import { useTranslation } from '../../../hooks/locale'
import { Subtitle, Title } from '../common/styles'
import { FaqSection } from '../../../transports/home-page-transport'

interface FaqsProps {
    faqs: FAQTransport[]
    location: string
    templateFaqSection: FaqSection | null
}

const FAQSection: FC<FaqsProps> = ({ faqs, location, templateFaqSection }) => {
    const { t } = useTranslation()
    const faqSectionSubtitle = `${t('faqSubTitle')} ${location}`

    const faqData = useMemo(() => {
        if (faqs && faqs.length > 0) {
            return faqs
        }
        if (templateFaqSection?.questionAnswers) {
            return templateFaqSection.questionAnswers.filter(qa => qa.question && qa.answer)
        }
        return []
    }, [faqs, templateFaqSection])

    if (faqData.length === 0) {
        return null
    }

    return (
        <Container id="faqs">
            <TitleSubtitleWrapper>
                <Title>{t('faqsTitle')}</Title>
                <Subtitle>{faqSectionSubtitle}</Subtitle>
            </TitleSubtitleWrapper>
            <ContentWrapper>
                {faqData.map(
                    faq =>
                        faq.question &&
                        faq.answer && (
                            <FAQItem key={faq.question}>
                                <Question>{faq.question}</Question>
                                <CustomMarkdown>{faq.answer}</CustomMarkdown>
                            </FAQItem>
                        ),
                )}
            </ContentWrapper>
        </Container>
    )
}

export default memo(FAQSection)
